import { useUser } from '@clerk/react-router';
import { isDefined } from 'app-shared/utils';
import { useEffect } from 'react';

import { useRefreshCurrentUser } from '@/session/hooks/useRefreshCurrentUser';

// Clerk owns names and emails, and people change them in Clerk's profile
// screen. When Clerk's copy changes, and once when the app opens (it may have
// changed on another device), the server re-reads it from Clerk.
export const ClerkUserProfileSyncEffect = () => {
  const { user } = useUser();
  const { refreshCurrentUser } = useRefreshCurrentUser();
  const clerkUserUpdatedAt = user?.updatedAt?.getTime();

  useEffect(() => {
    if (!isDefined(clerkUserUpdatedAt)) {
      return;
    }

    void refreshCurrentUser();
  }, [clerkUserUpdatedAt, refreshCurrentUser]);

  return null;
};
